"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPropertySearch = void 0;
exports.defaultPropertySearch = {
    translate: {
        hongKongPropertySearch: 'Hong Kong Property Search',
        beginYourSearch: 'Begin Your Search',
    },
};
